export default __webpack_public_path__ + "static/media/FirstBase-3.8c715bf2.jpg";